/**
 * Підпис одиниці виміру обсягу потреби. Коди `m3`, `pcs`, `t` локалізуються; інші
 * (з ERP приходять уже українські, напр. `шт`, `рул`) показуються як є; порожня — тонни.
 */
export const getUnitLabel = (unit?: string | null): string => {
    if (unit === 'm3') return 'м³'
    if (unit === 'pcs') return 'шт'
    if (unit === 't' || !unit) return 'т'
    return unit
}
